module.exports = __webpack_public_path__ + "img/padlock.7e9daac6.svg";